<template>
  <div class="result">
    <img src="@/assets/img/pic_banner.png" alt />
    <div class="nav_pos">
      当前位置：
      <label class="index" @click.stop="$router.push('/')">首页</label>
      > {{ blacklistSupplier == true ? '解禁审核进度查询' : '注册入围审核进度查询' }}
    </div>
    <div class="msg_content">
      <div class="title">{{ blacklistSupplier == true ? '解禁审核信息' : '入围审核信息' }}</div>
      <div class="list">
        <div class="item" v-for="(item, index) in msgList" :key="index">
          <div class="name">{{ item.title }}</div>
          <div class="msg">{{ item.msg }}</div>
        </div>
      </div>
    </div>
    <div class="btn_1" @click="submit(blacklistSupplier)" v-if="auditState === '不通过' || auditState === '撤销' || auditState == '草稿'">重新修改</div>
    <div class="btn_1" @click="cancel(blacklistSupplier)" v-if="auditState === '流程审核中'">撤回修改</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      height: document.body.clientHeight - 270 + 'px',
      sysNum: this.$route.query.sysNo,
      auditState: '撤销',
      userName: '',
      sysNo: '',
      supplierCategory: '',
      loginName: '',
      blacklistSupplier: false,
      socialCreditCode: '',
      msgList: [
        {
          title: '申请时间',
          msg: ''
        },
        {
          title: '审核状态',
          msg: ''
        },
        {
          title: '审核意见',
          msg: ''
        },
        {
          title: '说明',
          msg: '1、提交入围申请后，一般3-5个工作日完成审核。2、审核通过后，供应商可查看我司发布各类招标、竞价采购活动。3、审核不通过，请按审核意见修改入围申请材料后，再重新提交我司审核'
        }
      ]
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    submit(blacklistSupplier) {
      let that = this
      if (blacklistSupplier == true) {
        var ruleForm = {
          socialCreditCode: this.socialCreditCode
        }
        this.$router.push({
          path: '/unbanInform',
          query: {
            ruleForm: JSON.stringify(ruleForm),
            isEnter: true
          }
        })
      } else {
        if (that.supplierCategory == 0) {
          that.$router.push({
            //传外键值到审核进度详细页面
            path: '/RegisterForm',
            query: { loginName: that.loginName }
          })
        } else {
          that.$router.push({
            //传外键值到审核进度详细页面
            path: '/personal',
            query: { loginName: that.loginName }
          })
        }
      }
    },

    cancel(blacklistSupplier) {
      let that = this
      that.showLoading()
      if (blacklistSupplier == true) {
        this.getRequest('/SupplierLogin/CancelFlow2948?userName=' + that.userName + '&sysNo=' + that.sysNo)
          .then((res) => {
            var data = res.data
            if (data.errcode == 0) {
              this.getInfo()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.getRequest('/SupplierLogin/CancelFlow2903?userName=' + that.userName + '&sysNo=' + that.sysNo)
          .then((res) => {
            var data = res.data
            if (data.errcode == 0) {
              this.getInfo()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },

    getInfo() {
      let that = this
      that.showLoading()

      this.getRequest('/SupplierLogin/EntryflowDetail?sysNo=' + that.sysNum)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            that.hideLoading()
            that.msgList[0].msg = data.createDate
            that.msgList[1].msg = data.auditState
            that.msgList[2].msg = data.auditContent
            that.auditState = data.auditState
            that.userName = data.userName
            that.sysNo = data.sysNo
            that.supplierCategory = data.supplierCategory
            that.loginName = data.loginName
            that.blacklistSupplier = data.blacklistSupplier
            that.socialCreditCode = data.socialCreditCode
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  .btn_1 {
    font-weight: bold;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin: 25px 0 40px;
    width: 160px;
  }
  .msg_content {
    .title {
      padding: 10px 0;
      margin: 0 35px;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      border-bottom: 1px solid #95c7f0;
    }
    .list {
      margin: 15px 50px;
      .item {
        display: flex;
        align-items: stretch;
        .name {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          flex: 0 0 150px;
          padding: 15px 5px;
          border: 1px solid #fff;
          background: #d8eafa;
          text-align: right;
        }
        .msg {
          flex: 1;
          padding: 15px 5px;
          border: 1px solid #fff;
          background: #f2f2f2;
        }
      }
    }
  }
}
</style>
